import React, { PureComponent } from 'react';

import { Popconfirm as AntPopconfirm } from 'antd';
import { services } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { errorHandle } from '../../services';

const api = services.api;
/**
 * 删除
 */
export class CategoryDeleteButton extends PureComponent<any, any> {

    onDeleteItem = (id: number, entity: Entity, categoryTreeEntity: Entity) => {
        api.delete(
            { display_category_id: id },
            { apiPath: '/display_category/:display_category_id' }
        ).then(() => {

            // 列表数据刷新
            entity.search({
                ...entity.params,
                ...entity.filters,
            });

            // 刷新树
            categoryTreeEntity.get({});
        })
        .catch(errorHandle);
    };

    render() {
        const { row: { id }, entity, categoryTreeEntity } = this.props;
        const confirmProps = {
            title: '确定要删除吗？',
            okText: '确定',
            cancelText: '取消',
        };
        return (
            <AntPopconfirm {...confirmProps} onConfirm={this.onDeleteItem.bind(this, id, entity, categoryTreeEntity)}>
                <a className="table-action-column-item">
                    删除
                </a>
            </AntPopconfirm>
        );
    }
}
